<template>
  <div
    class="flex flex-col md:flex-row justify-between md:items-center md:mb-8 mb-4"
  >
    <h1 class="font-semibold text-[28px] text-black">Report</h1>
    <div class="flex flex-col md:flex-row gap-2">
      <div class="card flex rounded-[5px] py-2 gap-1 items-center">
        <p class="text-[16px] font-bold">Campaign Name:</p>

        <p class="text-[16px] font-medium text-primary">{{ campaignName }}</p>
      </div>

      <div class="card flex rounded-[5px] gap-1 py-2 items-center">
        <p class="text-[16px] font-bold">Campaign Date:</p>

        <p class="text-[16px] text-primary">
          {{ startAt.split("T")[0] }} <span class="text-black">to</span>
          {{ endAt.split("T")[0] }}
        </p>
      </div>
    </div>
  </div>

  <div class="flex mb-[20px]">
    <div class="flex md:flex-row flex-col gap-4 w-full">
      <div v-for="(x, index) in data" :key="index" class="md:w-[25%]">
        <div>
          <StatisticsCard :data="x" class="w-full" />
        </div>
      </div>
    </div>

    <!-- <div class="Second card flex justify-around items-center pb-0 w-full rounded-[5px]">
            <div class="flex justify-between items-center">
                <img src="../../assets/smile.svg" />
            </div>

            <div class="flex flex-col items-start">
                <p class="text-[37px] font-semibold text-secondary text-left">Superb!</p>
                <p class="text-[28px]">You Achieve</p>
                <p class="text-[28px] font-semibold">98.9%</p>
                <p class="text-[16px]">Of your campaign goals</p>
            </div>
        </div> -->
  </div>
  <div class="card rounded-[5px]">
    <div class="flex justify-between items-center">
      <p class="text-[16px] font-bold text-primary">Total Impressions</p>
      <tool-tip
        title="Impressions"
        discription="The number of people with the highest probability of seeing your ad."
      >
      </tool-tip>
    </div>
    <p class="text-[28px] font-semibold">{{ impressions }}</p>
    <div id="chart">
      <apexchart
        type="bar"
        height="350"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import StatisticsCard from "../../components/UI/Cards/StatisticsCard.vue";
// import LineChart from "../../components/UI/Chats/LineChart.vue";
// import RadialBar from "../../components/UI/Chats/RadialBar.vue";
import store from "../../store";
import ToolTip from "../../components/UI/ToolTip.vue";

export default {
  components: { StatisticsCard, ToolTip },
  data() {
    return {
      campaignName: "",
      startAt: "",
      endAt: "",
      impressions: "",
      data: [
        {
          name: "",
          value: "",
          icon: "budget",
          info: "Total Budget",
        },
        {
          name: "",
          value: "0km",
          icon: "DistanceCovered",
          info: "  Distance Covered",
        },
        {
          name: "",
          value: "",
          icon: "cpm",
          info: "CPM",
        },
        {
          name: "",
          value: "",
          icon: "Impressions",
          info: "Total ad loops",
        },
      ],

      chartOptions: {
        dataLabels: {
          enabled: false,
        },
        colors: ["#369DA3"],
        plotOptions: {
          bar: {
            borderRadius: 5,
            columnWidth: "50%",
          },
        },
        chart: {
          id: "basic-bar",
        },
        xaxis: {
          labels: {
            show: false,
            style: { fontSize: "14px", fontWeight: 600 },
          },
          categories: [
            // "1 - 11 - 2022",
            // "2 - 11 - 2022",
            // "3 - 11 - 2022",
            // "4 - 11 - 2022",
            // "5 - 11 - 2022",
            // "6 - 11 - 2022",
            // "7 - 11 - 2022",
            // "8 - 11 - 2022",
          ],
        },
        yaxis: {
          reversed: false,
          labels: {
            formatter: function (val, index) {
              return val.toLocaleString();
            },
            style: { fontSize: "14px", fontWeight: 600 },
          },
        },
      },
      series: [
        {
          name: "",
          data: [],
          // data: [40000, 30000, 50000, 30000, 20000, 30000, 50000, 60000],
        },
      ],
      charts: [],
    };
  },
  mounted() {
    this.getStatistics();
    this.startAt = this.$route.query.start;
    this.endAt = this.$route.query.end;
  },
  computed: {},
  methods: {
    async getStatistics() {
      try {
        store.commit("toggleLoading");
        let api = "https://publish.dkilo.com/api/statistics";
        const response = await axios.get(api, {
          headers: {
            token: localStorage.getItem("token"),
            "Country-Code": this.$store.state.auth.country_code,
          },
          params: {
            campaign_id: this.$route.query.campaign_id,
            start: this.$route.query.start,
            end: this.$route.query.end,
          },
        });
        if (this.$store.state.auth.country_code === "EG") {
          this.data[0].value = `${response.data.Budget.toLocaleString()} EGP`;
        } else if (this.$store.state.auth.country_code === "SA") {
          this.data[0].value = `${response.data.Budget.toLocaleString()} SAR`;
        }
        this.data[1].value = response.data.distance / 1000;
        this.data[2].value = response.data.cpm;
        this.data[3].value = response.data.AdLoop;
        this.impressions = response.data.impressions;
        this.campaignName = response.data.TargetCampaign.campaign_title;
        // this.startAt = response.data.TargetCampaign.starts_at;
        // this.endAt = response.data.TargetCampaign.ends_at;
        this.charts = [];
        this.charts = response.data.chart;
        this.series[0].data = Object.values(this.charts).map((el) => {
          return el.modulated_impressions;
        });
        this.chartOptions = { xaxis: { categories: Object.keys(this.charts) } };
        store.commit("toggleLoading");
      } catch (error) {
        store.commit("toggleLoading");
      }
    },
  },
};
</script>

<style>
.First {
  width: 70% !important;
}
.Second {
  width: 30% !important;
}
</style>
